// removed by extract-text-webpack-plugin
module.exports = {"content":"Review__content___3mdlU","container":"Review__container___14tAu","link":"Review__link___hgdMp"};